import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { resolveSeo } from "@/lib/seo-config";

// Watches route changes and applies the matching SEO head + JSON-LD metadata.
export default function RouteSeo() {
  const location = useLocation();

  useEffect(() => {
    resolveSeo(location.pathname);
  }, [location.pathname]);

  return null;
}